import React from 'react';
import { IonButton, IonIcon } from '@ionic/react';
import { 
  arrowForward, 
  arrowBack, 
  close, 
  checkmarkCircle
} from 'ionicons/icons';
import './CenteredTutorialModal.css';

const CenteredTutorialModal = ({
  stepData,
  progress,
  onNext,
  onPrevious,
  onSkip,
  onComplete,
  currentStep
}) => {
  const handleNext = () => {
    if (stepData?.showComplete) {
      onComplete();
    } else {
      onNext();
    }
  };

  return (
    <div className="centered-tutorial-modal">
      {/* Progress bar */}
      <div className="centered-tutorial-progress">
        <div className="centered-tutorial-progress-bar">
          <div 
            className="centered-tutorial-progress-fill"
            style={{ width: `${progress.percentage}%` }}
          />
        </div>
      </div>

      {/* Close button */}
      <button 
        className="centered-tutorial-close"
        onClick={onSkip}
        aria-label="Close tutorial"
      >
        <IonIcon icon={close} />
      </button>

      {/* Content */}
      <div className="centered-tutorial-content">
        <h3 className="centered-tutorial-title">
          {stepData.showComplete && <IonIcon icon={checkmarkCircle} className="centered-tutorial-success-icon" />}
          {stepData.title}
        </h3>
        <div className="centered-tutorial-description">
          {stepData.description.split('\n').map((line, index) => {
            // Handle empty lines as spacing
            if (line.trim() === '') {
              return <br key={index} />;
            }
            
            // Process bold text (**text**)
            const processedLine = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                                    .replace(/\*(.*?)\*/g, '<em>$1</em>');
            
            return (
              <div key={index} dangerouslySetInnerHTML={{ __html: processedLine }} />
            );
          })}
        </div>

        {/* Navigation buttons - exact same structure as original */}
        <div className="centered-tutorial-actions">
          <div className="centered-tutorial-controls-left">
            {stepData.showSkip && (
              <IonButton 
                fill="clear" 
                onClick={onSkip}
                className="centered-tutorial-skip-button"
              >
                {stepData.skipText || 'Skip Tutorial'}
              </IonButton>
            )}
          </div>
          
          <div className="centered-tutorial-controls-right">
            {currentStep > 0 && (
              <IonButton 
                fill="clear" 
                onClick={onPrevious}
              >
                <IonIcon icon={arrowBack} slot="start" />
                Back
              </IonButton>
            )}
            
            {stepData.showNext && (
              <IonButton 
                onClick={handleNext}
                className={stepData.encourageNext ? 'centered-tutorial-encouraged-button' : ''}
              >
                {stepData.showComplete ? (
                  <>
                    <IonIcon icon={checkmarkCircle} slot="start" />
                    Complete
                  </>
                ) : (
                  <>
                    {stepData.nextText || 'Next'}
                    <IonIcon icon={arrowForward} slot="end" />
                  </>
                )}
              </IonButton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CenteredTutorialModal;
